import { createFileRoute, Outlet } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/vehicles")({
  loader: () => ({ crumb: "Vehicles" }),
  component: RouteComponent
})

function RouteComponent() {
  return <Outlet />
}
